import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'craft-html-tooltip',
  template: `
    <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="context"></ng-container>
  `,
  styles: [
    `
      .craft-html-tooltip {
        max-width: 320px;
      }
    `,
  ],
  imports: [NgIf, NgTemplateOutlet],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CraftHtmlTooltipComponent {
  @Input() template: TemplateRef<any> | null = null;
  @Input() context: any;

  constructor() {}
}
